module.exports = __webpack_public_path__ + "img/sb_br_cj.963e3c23.png";